import { useGetLatestExamCourseAnalysisReportCreatedAtQuery } from '@report/graphql';
import { Link } from '@report/router';
import { ArrowBackRoundedIcon, Button, PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

export default function ExamCourseAnalysisReportPageHeader() {
  const { data } = useGetLatestExamCourseAnalysisReportCreatedAtQuery();

  const latestCreatedAt = formatDateTime(
    data?.reportGetLatestExamCourseAnalysisReportCreatedAt.latestCreatedAt,
  );

  return (
    <PageHeader
      linkAdornment={
        // TODO: replace with NavigateBackLink component in report/components package
        <Button
          variant='text'
          component={Link}
          to='/reports'
          sx={{
            p: 0,
            m: 0,
            justifyContent: 'flex-start',
            color: (theme) => theme.palette.text.secondary,
          }}
          startIcon={<ArrowBackRoundedIcon />}
        >
          Back
        </Button>
      }
      title='รายงานวิเคราะห์ผลการสอบตามหลักสูตร'
      subtitleSection={
        <>
          <Text variant='body2' color='text.secondary'>
            สรุปผลคะแนนและอัตราการผ่านของผู้เข้าสอบในแต่ละหลักสูตร
          </Text>
          <Text variant='body2' color='text.secondary'>
            อัปเดตข้อมูลล่าสุด: {latestCreatedAt}
          </Text>
        </>
      }
    />
  );
}
